import "./App.css";
import BirthdayCard from "./components/birthdayCard";
import balloons from "./balloons.png";
import ReactPlayer from "react-player";
import { useCallback, useState } from "react";

function App() {
  const [backgroundPlayerPlaying, setBackgroundPlayerPlaying] = useState(true);

  const onCardVideoPlaybackChange = useCallback((cardVideoIsPlaying) => {
    setBackgroundPlayerPlaying(!cardVideoIsPlaying);
  }, []);

  return (
    <div className="App">
      <BirthdayCard onCardVideoPlaybackChange={onCardVideoPlaybackChange} />
      <img src={balloons} className="balloons" alt="balloons" width="600" />
      <ReactPlayer
        loop={true}
        controls={true}
        playing={backgroundPlayerPlaying}
        volume={0.2}
        url="https://www.youtube.com/watch?v=aUe696XbytU"
        style={{
          marginTop: "20px",
        }}
      />
    </div>
  );
}

export default App;
